module.exports = __webpack_public_path__ + "static/media/ikke-fossilfri-klimapartner.dd375f99.png";